import { Component, input, Input } from '@angular/core';
import { AppRoutes } from '@core/enums/routes.enum';
import { environment } from '@environments/environment';
import { SettingIndexedDbModel } from '@capturum/complete';

@Component({
    selector: 'app-header',
    templateUrl: 'header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent {
  @Input() public showNavbar: boolean;
  @Input() public isVisible: boolean;
  public showProjectInfo = input<boolean>(true);
  public showUserMenu = input<boolean>(true);
  public fixedHeader = input<boolean>(true);

  public AppRoutes: typeof AppRoutes = AppRoutes;
  public homePageUrl = '/dashboard';
  public appName = `${environment.appName}`;
  public title = `${SettingIndexedDbModel.getValue('LeadPortal.tenant_translation_key')}`;
}
